// extracted by mini-css-extract-plugin
export default {"Text":"shared-module__Text--Vv2q2"};